import axios from "axios";
import { jwtDecode } from "jwt-decode";

function isTokenExpired(token: string) {
  try {
    const { exp } = jwtDecode(token);
    if (exp) {
      return Date.now() >= exp * 1000;
    }
  } catch {
    return true;
  }
}

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_SRV_URL}${process.env.REACT_APP_API_PATH}`,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("@Blue:token");

  if (token) {
    if (isTokenExpired(token)) {
      localStorage.clear();
      window.location.href = "/";
      return Promise.reject(new Error("Token expired"));
    }

    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default instance;
